import React from 'react';

export function withLines(text: string | undefined) {
    if (!text) {
        return '';
    }

    return text
        .replace(/\n\s*\n/g, '\n')
        .split('\n')
        .map((x, i) => (
            <span key={i}>
                {x}
                <br />
            </span>
        ));
}
